import React, { useState } from "react";
import { Link, withRouter, useHistory } from "react-router-dom";
import { registerAttendeeNew } from "../../actions/attendeeActions";
import materialize from "materialize-css"
import Localization from "../localization/localization"
import StepWizard from "react-step-wizard";

import { Email } from "./Email"
import { EstudianteInformation } from "./EstudianteInformation";


const EstudianteNew = () => {
    const [state, updateState] = useState({
        form: {
            nombres: "",
            apellidos: "",
            email: "",
            nacimiento: "",
            sexo: "",
            ciudad: "",
            estado: "",
            pais: "MX",
            codigoPostal: "",
            universidad: "",
            categoria: "ESTUDIANTE",
            tipoRegistro: "pre",
            locale: "es",
        }
    });

    const [disableSubmit, setdisableSubmit] = useState(false);

    const locale = Localization.getLocalizationInstance(localStorage.getItem("exmi_language"));
    const history = useHistory();

    const updateForm = (key, value) => {
        const { form } = state;

        form[key] = value;
        updateState({
            ...state,
            form,
        });

        if (key === "pais") {  
            form["ciudad"] = "";
            updateState({
              ...state,
              form,
            });
        }
    };

    const submitForm = () => {

        //e.preventDefault();

        let language = localStorage.getItem("exmi_language");
        if (language == null)
            language = "es";

        const newAttendee = {
            nombres: state.form.nombres,
            apellidos: state.form.apellidos,
            email: state.form.email,
            nacimiento: state.form.nacimiento,
            sexo: state.form.sexo,
            ciudad: state.form.ciudad,
            pais: state.form.pais,
            estado: state.form.estado,
            codigoPostal: state.form.codigoPostal,
            universidad: state.form.universidad,

            categoria: state.form.categoria,
            tipoRegistro: state.form.tipoRegistro,

            locale: language
        }

        registerAttendeeNew(newAttendee)
            .then(res => history.push("/landing?&id=" + res.data))
            .catch(error => {
                setdisableSubmit(false);
                materialize.toast({ html: locale.button_submission_error })
            });
    }

    // Do something on step change
    const onStepChange = (stats) => {
        window.scroll(0, 0);
        materialize.AutoInit();
        materialize.updateTextFields();
    };

    const setInstance = SW => updateState({
        ...state,
        SW,
    });


    return (
        <div className="col s12 m12 l7 container contentaligned overflowDiv">
            <Link to="/" className="btn-flat waves-effect">
                <i className="material-icons left">keyboard_backspace</i> {locale.dashboard_comprador_label_backtohome}
            </Link>
            <h4>
                <b>{locale.auth_student_label_formtitle}</b>
            </h4>
            <StepWizard
                onStepChange={onStepChange}
                //isHashEnabled
                // comment out for default transitions
                instance={setInstance}
            >
                <Email update={updateForm} locale={locale} form={state.form} />
                <EstudianteInformation update={updateForm} locale={locale} form={state.form} submit={submitForm} disableSubmit={disableSubmit}/>
            </StepWizard>
        </div>
    );
};


export default (withRouter(EstudianteNew));
